<script>
    import ValidacaoForm from "../../Classes/ValidacaoForm";
    import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
    import Constantes from "../../Classes/Constantes";
    import Conexoes from "../../Classes/Conexoes";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";

    import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
    import { DadosLogin } from "../../Classes/Stores";
    import InserirDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
    import { ItemInserir, Tipo } from "../../Classes/ItemInserir";

    export let id_usuario;
    export let id_assessoria;

    let tabela = "teste_corrida";
    let apiInsercao = Constantes.api_inserir_sem_query_code;
   

       const itens = [
        new ItemInserir({
            rotulo: "Tipo de teste",
            nomeColuna: "id_tipo_teste",
            tamanho: 30,
            tipo: Tipo.SELECAO,
            obrigatorio: true,
            config_drop_down: {
                api: Constantes.api_consultar_padrao,

                parametros: {
                    query_code: "consulta_generica_livre",
                    tabela: "tipos_testes_corrida",
                },
                nome_coluna_opcoes: "tipo_teste",
                nome_coluna_saida: "id",
                filtravel: false,
                itens: "",
            },
        }),
        new ItemInserir({
            rotulo: "Data do teste",
            nomeColuna: "data_teste",
            tamanho: 30,
            tipo: Tipo.DATA,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "Resultado",
            nomeColuna: "resultado",
            tamanho: 5,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
        }),

        new ItemInserir({
            rotulo: "",
            nomeColuna: "id_assessoria",
            valor:id_assessoria,
            tipo: Tipo.HIDDEN,
            obrigatorio: true,
        }),
        new ItemInserir({
            rotulo: "",
            nomeColuna: "id_usuario",
            valor: id_usuario,
            tipo: Tipo.HIDDEN,
            obrigatorio: true,
        }),
    ];

    function refresh(){
        window.location.reload();
    }
</script>

<InserirDadosBasico on:finalizado_sucesso={refresh}
    titulo={"Inserir teste"}
    api={apiInsercao}
    {itens}
    {tabela}
/>
